// extracted by css-extract-rspack-plugin
export default {"ToastParent":"ToastParent-LNEYks","toastParent":"ToastParent-LNEYks"};